import { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import CategoryContext from "./CategoryContext";
import axios from "axios";
const CategoryProvider = ({ children }) => {
  const [category, setCategory] = useState([]);

    const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [successMessage, setSuccessMessage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const userData = JSON.parse(sessionStorage.getItem("admin_user"));

  const { UserID, AuthCode } = userData.BoAcntLst[0];

  //to show category list
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const requestBody = {
          ComID: "EH25",
          UserID:UserID,
          Flag:  "S", 
          AuthCode:AuthCode,
          IsActive: "A"
        };

        const response = await axios.post(
          "https://testing.esnep.com/magnessa/api/bo/product-category",
          requestBody,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data?.BoProdLst) {
            setCategory(response.data.BoProdLst);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  

  return (
    <CategoryContext.Provider value={{ category,loading,selected, setSelected,successMessage,setSuccessMessage }}>
      {children}
    </CategoryContext.Provider>
  );
};

export default CategoryProvider;
